// extracted by mini-css-extract-plugin
export default {"wrapper":"ProfileSettingsForm_wrapper__0RAvT","title":"ProfileSettingsForm_title__QHhqP","form":"ProfileSettingsForm_form__GmYqT"};